/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Especifica la definicion de lso tipo de contenidos soportados para suministrar informacion texual.
 */
export type TextSupportedContentType = 'HTML' | 'MARKDOWN' | 'PLAIN';

export const TextSupportedContentType = {
    HTML: 'HTML' as TextSupportedContentType,
    MARKDOWN: 'MARKDOWN' as TextSupportedContentType,
    PLAIN: 'PLAIN' as TextSupportedContentType
};

